
export default "/assets/document-arrow-down-micro.64bc2609.svg"